import { render } from "./SectionCollection.vue?vue&type=template&id=d2f2f238"
import script from "./SectionCollection.vue?vue&type=script&lang=js"
export * from "./SectionCollection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__